import PaySession from '../smoothr-web-app-core/models/PaySession';
import { sleep } from '../smoothr-web-app-core/utils/utils';
import { Router } from '@angular/router';
import { PaySessionSplitType } from '../smoothr-web-app-core/enums/PaySessionSplitType';

export async function navigateCorrespondingToSession(
	router: Router,
	prevPaySession: PaySession | null,
	paySession: PaySession | null,
	force: boolean = false
) {
	console.log('navigateCorrespondingToSession()');
	const page = await getCurrentComponentName(router);
	console.log({ page, force });

	if (!force && (page === 'PaymentSuccessPage' || page === 'PaymentFailedPage')) {
		console.log(`Do not navigate automatically away from ${page}`);
		return;
	}

	if (page === 'HomePage' && !force) {
		console.log('Do not navigate HomePage should not navigate automatically');
		return;
	}
	if (!paySession) {
		await navigateHome(router, prevPaySession?.readableId, prevPaySession?.tableNumber);
		return;
	}
	switch (paySession?.splitType) {
		case null:
		case PaySessionSplitType.FULL:
			await navigateToChecks(router, force);
			break;
		case PaySessionSplitType.SEPARATE:
			await navigatePaySeparate(router, force);
			break;
		case PaySessionSplitType.EQUAL:
			await navigatePayEqual(router, force);
			break;
		default:
			await navigateHome(router);
	}
}

export async function navigateToChecks(router: Router, force: boolean = false) {
	console.log('navigateToChecks()');

	const componentName = await getCurrentComponentName(router);
	const isOnPaymentFailedOrChecks =
		!force &&
		(componentName === 'PaymentFailedPage' ||
			componentName === 'ChecksPage' ||
			componentName === 'HomeStatusPage' ||
			componentName === 'StatusPage');
	if (isOnPaymentFailedOrChecks) {
		return;
	}
	await router.navigate(['/checks'], {
		replaceUrl: true,
	});
}

export async function navigatePaySeparate(router: Router, force: boolean = false) {
	console.log('navigatePaySeparate()');

	const componentName = await getCurrentComponentName(router);
	const allowToOpenPaySplit =
		(componentName !== 'PaySplitPage' && componentName !== 'PaymentSuccessPage' && componentName !== 'PaymentFailedPage') || force;

	console.log({
		componentName,
		allowToOpenPaySplit,
	});
	if (!allowToOpenPaySplit) {
		return;
	}
	await router.navigate(['/pay-split'], {
		replaceUrl: true,
	});
}

export async function navigatePayEqual(router: Router, force: boolean = false) {
	console.log('navigatePayEqual()');

	const componentName = await getCurrentComponentName(router);
	const allowToOpenEqual =
		(componentName !== 'PayEqualPage' && componentName !== 'PaymentSuccessPage' && componentName !== 'PaymentFailedPage') || force;
	console.log({
		componentName,
		allowToOpenEqual,
	});
	if (!allowToOpenEqual) {
		return;
	}

	await router.navigate(['/pay-equal'], {
		replaceUrl: true,
	});
}

export async function navigateHome(router: Router, venueReadableId: string | null = null, tableNumber: string | null = null) {
	console.log('navigateHome()');

	while (!router.navigated) {
		await sleep(50);
	}
	// Avoid navigating if we are already on HomePage
	const componentName = await getCurrentComponentName(router);
	const url = router.url;
	console.log({
		componentName,
		navigated: router.navigated,
		url: url,
	});
	const allowNavigation =
		componentName !== 'HomePage' &&
		componentName !== 'PaymentSuccessPage' &&
		componentName !== 'PaymentFailedPage' &&
		componentName !== 'HomeStatusPage' &&
		componentName !== 'StatusPage';

	if (!allowNavigation) {
		return;
	}

	if (venueReadableId && tableNumber) {
		console.log('PrevPaySession seems to have a venue and table. Navigating home to that.');
		await router.navigate([`/${venueReadableId}/${tableNumber}`], {
			replaceUrl: true,
		});
		return;
	}

	await router.navigate(['/'], {
		replaceUrl: true,
	});
}

export async function getCurrentComponentName(router: Router): Promise<string | null> {
	while (!router.navigated) {
		await sleep(50);
	}
	// Avoid navigating if we are already on HomePage
	let snap = router.routerState.snapshot.root;
	while (snap.firstChild) {
		snap = snap.firstChild;
	}
	return ((snap.routeConfig?.component as any)?.name ?? (snap.component as any)?.name)?.replace('_', '') ?? null;
}
